
import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import QRCode from 'react-qr-code';
import io from 'socket.io-client';
import axios from 'axios';
import  chatService  from '../../services/chatService';
import "../../assets/scss/custom/components/chatbot.scss"
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import ModalProductos from '../mostrarproductos/ModalProductos';
import { useLayoutEffect } from 'react';
import validateFaceImage from '../../utils/validateFace';

//PRODUCCION
const socket = io('https://tiendabastet.duckdns.org:8084');
const baseUrl = 'https://tiendabastet.duckdns.org:8084';
//DESARROLLO
//const socket = io('http://127.0.0.1:5000');
//const baseUrl = 'http://127.0.0.1:5000';


const ChatComponent = () => {
  const history = useHistory();
  const failedAnalysisCount = useRef(0);
  const [messages, setMessages] = useState([]);
  const [userMessage, setUserMessage] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [userEmail, setUserEmail] = useState('no definido');
  const [uploadUrl, setUploadUrl] = useState('');
  const [qrDisplayed, setQrDisplayed] = useState(false);
  const [mostrarProductos, setMostrarProductos] = useState(false);
  const [productosExtraidos, setProductosExtraidos] = useState([]);
  const [productosConImagen, setProductosConImagen] = useState([]);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [respuestaN8N, setRespuestaN8N] = useState(null);
  const [isBotTyping, setIsBotTyping] = useState(false);
  const [b, setB] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const messagesEndRef = useRef(null);
  const [mapaNombreAId, setMapaNombreAId] = useState({}); // clave: nombre, valor: id
  const location = useLocation();
  const [uniqueCode, setUniqueCode] = useState('');
  const [pendingImage, setPendingImage] = useState(null);
  const [mostrarModalDesdeBoton, setMostrarModalDesdeBoton] = useState(false);
  const chatEndRef = useRef(null);
  const [mostrarBotonNuevaConversacion, setMostrarBotonNuevaConversacion] = useState(() => {
    return localStorage.getItem('mostrarBotonNuevaConversacion') === 'true';
  });

const resetChat = () => {
  localStorage.removeItem('chatHistorial');
  localStorage.removeItem('lastImageUpload');
  localStorage.removeItem('mostrarProductos');
  localStorage.removeItem('mostrarBotonNuevaConversacion');

  setMessages([
    { text: '<strong>¿Quieres saber qué necesita tu piel?></strong> Escanea el QR y descubre tu diagnóstico facial en segundos.', sender: 'bot' },
    { text: '.▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲▲.', sender: 'bot', showQR: true}
  ]);

  setPendingImage(null);
  setQrDisplayed(true);
  setMostrarProductos(false);
  setMostrarModalDesdeBoton(false);
  setMostrarBotonNuevaConversacion(false);
};

useEffect(() => {
  if (messagesEndRef.current) {
    //messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
  }
}, [messages, mostrarProductos]);
useEffect(() => {
  const mostrarBotonGuardado = localStorage.getItem('mostrarBotonNuevaConversacion') === 'true';
  setMostrarBotonNuevaConversacion(mostrarBotonGuardado);
}, []);


//////////BOTON MOSTRAR PRODUCTOS TRUE/////////////////////
useEffect(() => {
  const mostrar = localStorage.getItem('mostrarProductos');
  if (mostrar === 'true') {
    setMostrarProductos(true);
  }
}, []);
 


// ✅ Captura el código único desde la URL
useEffect(() => {
  const params = new URLSearchParams(location.search);
  const code = params.get('code') || '';
  if (code) {
    console.log('Código detectado en URL8888:', code);
    setUniqueCode(code);
  } else {
    generateUniqueCode();
  }
}, [location]);


const generateUniqueCode = () => {
  const existingCode = localStorage.getItem('uniqueCodeUser');
  const code = existingCode || Math.random().toString(36).substring(2, 10);
  localStorage.setItem('uniqueCodeUser', code);
  setUniqueCode(code);

  const url = `$https://bastetderma.com/upload?code=${code}`;
  setUploadUrl(url);

  console.log('Código usado para URL y usuario:', code);
  console.log('URL generada para QR:', url);
};

///////////////////INICIALIZA EL SOCKET Y EL CODIGO QR ////////////////////////

useEffect(() => {
  if (!uniqueCode) return;

  let isMounted = true;
  console.log('Código único:', uniqueCode);

  const savedHistorial = localStorage.getItem('chatHistorial');
  if (savedHistorial) {
    try {
      const parsedHistorial = JSON.parse(savedHistorial);
      const mensajesFiltrados = parsedHistorial.slice(2, -1);

      const mensajes = [
        { text: '<strong>¿Quieres saber qué necesita tu piel?</strong> Escanea el QR y descubre tu diagnóstico facial en segundos.', sender: 'bot' },
        { text: '.▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲▲.', sender: 'bot', showQR: true},
        ...mensajesFiltrados
      ];

      setMessages(mensajes);
    } catch (e) {
      console.error('Error cargando historial de chat:', e);
      setMessages([
        { text: '<strong>¿Quieres saber qué necesita tu piel?</strong> Escanea el QR y descubre tu diagnóstico facial en segundos.', sender: 'bot' },
        { text: '.▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲▲.', sender: 'bot', showQR: true}
      ]);
    }
  } else {
    setMessages([
      { text: '<strong>¿Quieres saber qué necesita tu piel?</strong> Escanea el QR y descubre tu diagnóstico facial en segundos.', sender: 'bot' },
      { text: '.▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲▲.', sender: 'bot', showQR: true}
    ]);
  }

  socket.emit('join_room', uniqueCode);

  const savedUpload = localStorage.getItem('lastImageUpload');
  if (savedUpload) {
    const parsed = JSON.parse(savedUpload);
    const isRecent = Date.now() - parsed.time < 10000;
    if (isRecent && parsed.code === uniqueCode) {
      console.log('Imagen recuperada de localStorage:', parsed.url);
      setPendingImage({ image_url: parsed.url });
      localStorage.removeItem('lastImageUpload');
    }
  }

  if (!qrDisplayed) setQrDisplayed(true);

  socket.on('connect', () => {
    console.log('Socket conectado con ID:', socket.id);
  });

  const handleNewImageSocket = (data) => {
    if (isMounted) setPendingImage(data);
  };

  socket.on('new_image_uploaded', handleNewImageSocket);

  return () => {
    isMounted = false;
    socket.off('new_image_uploaded', handleNewImageSocket);
  };
}, [uniqueCode]);

// Segundo useEffect para hacer scroll automático cada vez que cambian los mensajes
useEffect(() => {
  console.log('useEffect de scroll disparado, mensajes actualizados:', messages.length);
  if (chatEndRef.current) {
    setTimeout(() => {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
      console.log('Scroll realizado');
    }, 100);
  }
}, [messages]);


// ✅ Procesa imagen pendiente cuando uniqueCode esté disponible
useEffect(() => {
      if (uniqueCode && pendingImage) {
        handleNewImage(pendingImage);
        setPendingImage(null);
      }
}, [uniqueCode, pendingImage]);

// ✅ Escucha eventos postMessage (iframe)
// useEffect(() => {
//   const handleMessage = (event) => {
//     if (event.data?.type === 'imageUploaded' && event.data.imageUrl) {
//       console.log('📨 Imagen recibida por postMessage:', event.data.imageUrl);
//       setPendingImage({ image_url: event.data.imageUrl }); // ✅ Espera a uniqueCode
//     }
//   };

//   window.addEventListener('message', handleMessage);
//   return () => {
//     window.removeEventListener('message', handleMessage);
//   };
// }, []);

// ✅ Maneja la imagen recibida
const handleNewImage = async (data) => {
  if (!data.image_url || !uniqueCode) {
    console.warn('🔁 Esperando imagen o código único...');
    return;
  }

  console.log('Imagen recibida Socket', data.image_url);
  setMessages(prev => [...prev, { imageUrl: data.image_url, sender: 'user' }]);
  setIsBotTyping(true);
  setTimeout(() => {
    if (isBotTyping) {
      setMessages(prev => [
        ...prev,
        {
          text: '⏳ Estamos realizando un análisis profundo de tu piel, esto puede tardar unos segundos más. Gracias por tu paciencia.',
          sender: 'bot'
        }
      ]);
    }
  }, 20000); // 20 segundos

  try {
    // 1. Descargar la imagen
    const imageRes = await fetch(data.image_url);
    const imageBlob = await imageRes.blob();
    const imageFile = new File([imageBlob], 'uploaded-image.jpg', { type: imageBlob.type });

    // 2. Enviar al endpoint /analyze-skin
    const formData = new FormData();
    formData.append('file', imageFile);
    formData.append('uniqueCode', uniqueCode); //VALIDAR GUARDADO DE CONDICIONES

    const analyzeRes = await fetch(`${baseUrl}/analyze-skin`, {
      method: 'POST',
      body: formData
    });

    const analysisResult = await analyzeRes.json();
    console.log('🧴 Resultado del análisis de piel:', analysisResult);

    // Validar si todos los uiScores son 0
    const allUiScoresZero = ['redness', 'wrinkle', 'pore', 'acne', 'eye_bag', 'texture', 'firmness'].every(key =>
      (analysisResult?.[key]?.ui_score ?? 0) === 0
    );

    if (allUiScoresZero) {
        failedAnalysisCount.current += 1;
        console.warn('⚠️ Todos los valores uiScore son 0. Posible error en el análisis. ⚠️');

        setIsBotTyping(false);

        let message = '😊 Parece que tuvimos dificultades para analizar tu imagen. Asegúrate de que tu rostro esté bien iluminado, enfocado y visible. Intenta tomar o subir una imagen más clara y cercana para obtener mejores resultados.';

        if (failedAnalysisCount.current >= 3) {
          message = '😔 Parece que seguimos teniendo problemas para analizar tu imagen. No te preocupes, puedes contarme tu situación y condiciones de piel y con gusto te ayudaré. ¿Cuál es la condición que deseas consultar?';
        }

        setMessages(prev => [
          ...prev,
          {
            text: message,
            sender: 'bot'
          }
        ]);
      
        return; // Cancelar flujo para no enviar a Swagger
    }
    //Análisis válido: reiniciar contador
    failedAnalysisCount.current = 0;

    //Validar codigo de usuario
    if(userEmail != 'no definido'){
      uniqueCode = userEmail;
    }

     // 3. Armar el JSON que espera Swagger
    console.log("UNIQUECODE-- enviado con IMAGEN: ",uniqueCode);

    const payloadToSwagger = {
      userId: uniqueCode, // Lo que tengas como identificador
      predicciones: {
        redness: {
          uiScore: analysisResult?.redness?.ui_score ?? 0,
          rawScore: analysisResult?.redness?.raw_score ?? 0
        },
        wrinkle: {
          uiScore: analysisResult?.wrinkle?.ui_score ?? 0,
          rawScore: analysisResult?.wrinkle?.raw_score ?? 0
        },
        pore: {
          uiScore: analysisResult?.pore?.ui_score ?? 0,
          rawScore: analysisResult?.pore?.raw_score ?? 0
        },
        acne: {
          uiScore: analysisResult?.acne?.ui_score ?? 0,
          rawScore: analysisResult?.acne?.raw_score ?? 0
        },
        eye_bag: {
          uiScore: analysisResult?.eye_bag?.ui_score ?? 0,
          rawScore: analysisResult?.eye_bag?.raw_score ?? 0
        },
        texture: {
          uiScore: analysisResult?.texture?.ui_score ?? 0,
          rawScore: analysisResult?.texture?.raw_score ?? 0
        },
        firmness: {
          uiScore: analysisResult?.firmness?.ui_score ?? 0,
          rawScore: analysisResult?.firmness?.raw_score ?? 0
        }
      }
    };

    console.log('📦 Enviando a Swagger:', payloadToSwagger);

    // 4. Enviar al backend de Swagger
    const swaggerRes = await fetch('https://bastetderma.com/swagger/api/Chatbot/ImageChatbot', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payloadToSwagger)
    });

    const botResponse = await swaggerRes.json();
    console.log('🤖 Respuesta de Swagger:', botResponse);

    // 5. Mostrar en el chat
    setIsBotTyping(false);
    setMessages(prev => [
      ...prev,
      {
        text: botResponse?.respuesta || '✅ Análisis completado.',
        sender: 'bot'
      }
    ]);

    localStorage.setItem('chatSessionActive', 'true');
    

    if (productosExtraidos.length > 0) {
      mostrarProductosModal();
      setMessages(prev => [
        ...prev,
        {
          text: '🛍️ Adquiere tus productos aquí:',
          sender: 'bot',
          showButton: true
        }
      ]);
    }
  } catch (error) {
    console.error('❌ Error al procesar imagen:', error);
    setIsBotTyping(false);
    setMessages(prev => [
      ...prev,
      { text: '❌ Hubo un error al procesar la imagen. Intenta nuevamente.', sender: 'bot' }
    ]);
  }
};      



  // const validateEmailAndFetchImage = async () => {
  //   if (imageAlreadyAdded) return;

  //   try {
  //     const response = await axios.get(`https://dc33-38-51-234-78.ngrok-free.app/get-image-by-email`, {
  //       params: { code: uniqueCode, email: userEmail }
  //     });

  //     if (response.data.image_url) {
  //       const imageUrl = response.data.image_url;
  //       setMessages(prev => [...prev, { imageUrl, sender: 'user' }]);
  //       console.log("imagen recibida por qr desde el metodo validateEmail:", imageUrl);

  //       const res = await chatService.sendUrlImage(imageUrl, uniqueCode, userEmail);
  //       console.log("respuesta de n8n desde el metodo validateEmail:", res);
  //       setMessages(prev => [...prev, { text: res, sender: 'bot' }]);
  //       setImageAlreadyAdded(true);
  //     } else {
  //       alert("No se encontró ninguna imagen asociada a este correo. Por favor, suba una imagen.");
  //     }
  //   } catch (error) {
  //     console.error('Error obteniendo la imagen:', error);
  //     alert("Ocurrió un error. Verifique su conexión e intente nuevamente.");
  //   }
  // };

  const getImageUrlByEmail = async (userEmail, uniqueCode) => {
    const fullUrl = `${baseUrl}/get-image-by-email?code=${encodeURIComponent(uniqueCode)}&email=${encodeURIComponent(userEmail)}`;
    try {
      const res = await fetch(fullUrl, {
        method: "GET",
        headers: {
          "Accept": "application/json",
          "ngrok-skip-browser-warning": "true"  // ✅ Este header evita la advertencia
        }
      });
  
      const contentType = res.headers.get("content-type");
  
      if (!res.ok) {
        const errorText = await res.text();
        console.warn("Respuesta con error del backend:", res.status);
        console.error("Texto del error:", errorText.slice(0, 200));
        return null;
      }
  
      if (!contentType || !contentType.includes("application/json")) {
        const text = await res.text();
        console.error("⚠️ El backend devolvió HTML en vez de JSON. Primeros 200 caracteres:");
        console.error(text.slice(0, 200));
        return null;
      }
  
      const response = await res.json();
      console.log("✅ Respuesta del backend (get-image-by-email):", response);
  
      return response.image_url || null;
    } catch (error) {
      console.error("❌ Error al obtener la imagen:", error);
      return null;
    }
  };
  
  
  
  const normalizarTexto = (texto) => {
    return texto
      .toLowerCase()
      .normalize("NFD") // quita acentos
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s]/g, "") // quita puntuación
      .replace(/\s+/g, " ") // colapsa espacios
      .trim();
  };


 const compararProductos = (productosExtraidos, productosBackend) => {
  const productosBackendNormalizados = productosBackend.map(producto => ({
    original: producto,
    normalizado: normalizarTexto(producto)
  }));

  const productosFinales = [];

  for (const productoExtraido of productosExtraidos) {
    const normalizadoExtraido = normalizarTexto(productoExtraido);
    const palabrasClave = normalizadoExtraido.split(/\s+/);

    const frecuenciaPalabras = {};
    for (const palabra of palabrasClave) {
      frecuenciaPalabras[palabra] = productosBackendNormalizados.filter(p =>
        p.normalizado.includes(palabra)
      ).length;
    }

    // CAMBIO: Permitimos palabras que aparecen hasta 4 veces
    const palabrasFiltradas = palabrasClave.filter(
      palabra => frecuenciaPalabras[palabra] <= 4
    );

    let mejorCoincidencia = null;
    let maxCoincidencias = 0;

    for (const producto of productosBackendNormalizados) {
      const coincidencias = palabrasFiltradas.filter(palabra =>
        producto.normalizado.includes(palabra)
      ).length;

      if (coincidencias > maxCoincidencias) {
        maxCoincidencias = coincidencias;
        mejorCoincidencia = producto.original;
      }
    }

    // ✅ Consideramos coincidencias si al menos 1 palabra coincide
    if (mejorCoincidencia && maxCoincidencias >= 1 && !productosFinales.includes(mejorCoincidencia)) {
      productosFinales.push(mejorCoincidencia);
    }
  }

  if (productosFinales.length === 0) {
    return productosBackend.slice(0, 4);
  }

  return productosFinales;
};


  const sendMessage = async () => {
    if (selectedFile) {
      setImagePreview(null); //Limpiar vista previa de imagen
      setIsBotTyping(true); //Mostrar el indicador de que el bot está escribiendo
  
      if (!userEmail) {
        console.warn('Debe ingresar un correo electrónico antes de enviar la imagen.');
        setIsBotTyping(false); // Detener el indicador de carga
        return;
      }
  
      try {
        // Guardar una copia antes de limpiar
        const imageToSend = selectedFile;

        // Validar si la imagen tiene rostro
        const validationResult = await validateFaceImage(imageToSend);
        if (validationResult !== 'ok') {
          let msg = {
            'no-face': 'La imagen no contiene un rostro.',
            'too-small': 'El rostro detectado es demasiado pequeño.',
            'too-dark': 'La imagen está muy oscura.',
            'blurry': 'La imagen está borrosa.'
          }[validationResult] || 'Imagen inválida.';
        
          alert(`❌ ${msg}`);
          setIsBotTyping(false);
          return;
        }

  
        // 1. Subir imagen al backend
        const uploadFormData = new FormData();
        uploadFormData.append('file', imageToSend);
        uploadFormData.append('email', userEmail);
        uploadFormData.append('code', uniqueCode);
  
        const uploadRes = await fetch(`${baseUrl}/upload-with-email`, {
          method: 'POST',
          body: uploadFormData
        });
  
        const uploadData = await uploadRes.json();
        console.log('Imagen enviada con éxito:', uploadData);
        setSelectedFile(null); // Limpiar archivo después de enviar
  
        // 2. Obtener URL de la imagen desde el backend
        // const imageUrl = await getImageUrlByEmail(userEmail, uniqueCode);
        // if (imageUrl) {
        //   console.log("Imagen reeenviada del backend:", imageUrl);
        //   setMessages(prev => [
        //     ...prev,
        //     { type: 'image', imageUrl: imageUrl, sender: 'user' }
        //   ]);
        // } else {
        //   console.warn("No se encontró imagen en el backend.");
        // }
  
        // // 3. Enviar imagen para predicción (puede ser un procesamiento adicional)
        // const predictFormData = new FormData();
        // predictFormData.append('file', imageToSend);
        // predictFormData.append('uniqueCode', uniqueCode);
        // predictFormData.append('userEmail', userEmail);
  
        // const predictRes = await fetch(`${baseUrl}/predict-pruebas`, {
        //   method: 'POST',
        //   body: predictFormData
        // });
  
        // const contentType = predictRes.headers.get("content-type");
        // if (!contentType || !contentType.includes("application/json")) {
        //   const text = await predictRes.text();
        //   console.error("Respuesta no JSON, parece HTML. Primeros 200 caracteres:\n", text.slice(0, 200));
        //   return;
        // }
  
        // const predictData = await predictRes.json();
        // console.log("Respuesta de predicción:", predictData);
  
        // if (typeof predictData === 'string') {
        //   setMessages(prev => [
        //     ...prev,
        //     { text: predictData, sender: 'bot' }
        //   ]);
        // }
  
      } 
      catch (error) {
        console.error("Error en el proceso de imagen:", error);
      }
  
      setIsBotTyping(false); // Detener el indicador de carga
    } else if (userMessage.trim() !== '') {
      // Si no hay imagen, pero hay un mensaje de texto
      setMessages(prev => [
        ...prev,
        { text: userMessage, sender: 'user' }
      ]);
      
      const messageToSend = userMessage; // Guarda el mensaje
      setUserMessage(''); // Limpia caja texto
      setIsBotTyping(true);
      
      console.log("Mensaje enviado al backend:", messageToSend);
      
      try {
        const response = await fetch('https://bastetderma.com/swagger/api/Chatbot/MensajesChatbot', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userId: uniqueCode,
            mensaje: userMessage
          })
        });

        const data = await response.json();
        console.log("🧠 Respuesta del chatbot mensajes de texto Swagger:", data);
        console.log("UNIQUECODE-- enviado con mensaje: ",uniqueCode);

  
      //////////////////////extraerproductos(nombres)/////////////////////// 

        if (data && data.respuesta) {
          setRespuestaN8N(data.respuesta);
         
          setProductosConImagen([]);
          setMapaNombreAId({});
          setProductosExtraidos([]); // 🔁 Resetear antes de extraer nuevos
          const productosExtraidosRaw = extraerProductos(data.respuesta);
          console.log("--PRODUCTOS EXTRAIDOS RAW: ",productosExtraidosRaw)

          if (
            productosExtraidosRaw.length > 0 &&
            !(productosExtraidosRaw.length === 1 && productosExtraidosRaw[0] === "Bastet Derma")
          ) {

              fetch(`${baseUrl}/nombre-productos`, {
              method: "POST"
            })
            .then(res => res.json())
            .then(productosBackend => {
              console.log("PRODUCTOS EXTRAIDOS DEL BACKEND: ", productosBackend)
              const productosFinales = compararProductos(productosExtraidosRaw, productosBackend);
              console.log("Productos FINALES COMPARADOS: ",productosFinales)
            
              if (productosFinales.length > 0) {
                console.log("Productos recomendados finales:", productosFinales);
                setProductosExtraidos(productosFinales);
                setProductosConImagen([]);
                setMapaNombreAId({});

                // Mostrar modal directamente, sin esperar el useEffect
                setMostrarProductos(true);
                setMostrarModalDesdeBoton(false);
                setMostrarBotonNuevaConversacion(true);
                localStorage.setItem('mostrarBotonNuevaConversacion', 'true');

                obtenerImagenesProductos(productosFinales); // 🔧 pásalos como parámetro
                obtenerIdsProductos(productosFinales);

                setMessages(prev => [
                  ...prev,
                  { text: '🛍️ Adquiere tus productos aquí:', sender: 'bot', showButton: true }
                ]);
              }
               else {
                console.log("Fallo al extraer productos, invitamos a ver nuestra tienda.");
              }
            })
            .catch(error => {
              console.error("Error al obtener productos del backend:", error);
            });
          }

          setMessages(prev => [
            ...prev,
            { text: data.respuesta?.replace(/\n/g, "<br>"), sender: 'bot' }
          ]);

          
        } else {
          console.error("La respuesta de N8N no tiene el formato esperado:", data);
        }
  
      } catch (error) {
        console.error("Error en el fetch del mensaje de texto:", error);
      }
  
      setUserMessage(''); // Limpiar el mensaje del usuario
      setIsBotTyping(false); // Detener el indicador de carga
    }
    
  };
  
  const extraerProductos = (mensaje) => {
    const regex = /([A-Z][a-zA-ZáéíóúÁÉÍÓÚñÑüÜçÇ]+(?:\s+[A-Z][a-zA-ZáéíóúÁÉÍÓÚñÑüÜçÇ0-9+()\-]*){1,})/g;
    const productos = [];
    let match;

    while ((match = regex.exec(mensaje)) !== null) {
      const producto = match[0].trim();

      // Filtrar por longitud mínima para evitar falsos positivos
      if (producto.length >= 10 && !productos.includes(producto)) {
        productos.push(producto);
      }
    }

    console.log("[🔎] Productos extraídos:", productos);
    return productos;
  };


 useEffect(() => {
  const mostrarBotonGuardado = localStorage.getItem('mostrarBotonNuevaConversacion');
  if (mostrarBotonGuardado === 'true') {
    setMostrarBotonNuevaConversacion(true);
  }
}, []);
// Solo para el botón, no para el modal ni mostrarProductos
useEffect(() => {
  const botonVisible = localStorage.getItem('mostrarBotonNuevaConversacion') === 'true';
  setMostrarBotonNuevaConversacion(botonVisible);
  // NO tocar mostrarModalDesdeBoton ni mostrarProductos aquí
}, []);
useEffect(() => {
  // Forzar estados en falso al montar para que no se muestre modal sin click
  setMostrarProductos(false);
  setMostrarModalDesdeBoton(false);

  // También recupera el estado del botón nueva conversación (opcional)
  const mostrarBotonLS = localStorage.getItem('mostrarBotonNuevaConversacion') === 'true';
  setMostrarBotonNuevaConversacion(mostrarBotonLS);
}, []);


const mostrarProductosModal = () => {
  setMostrarProductos(true);
  setMostrarModalDesdeBoton(true);

  // Mostrar botón "Nueva conversación"
  setMostrarBotonNuevaConversacion(true);
  localStorage.setItem('mostrarBotonNuevaConversacion', 'true');

  obtenerImagenesProductos();

  if (Array.isArray(productosExtraidos) && productosExtraidos.length > 0) {
    obtenerIdsProductos(productosExtraidos);
  } else {
    console.warn('[mostrarProductosModal] productosExtraidos no está listo:', productosExtraidos);
  }
};



  
  const obtenerImagenesProductos = (productos) => {
    if (
      Array.isArray(productos) &&
      productos.length > 0 &&
      productos.every(nombre => typeof nombre === 'string' && nombre.trim() !== '')
    ) {
      const queryString = productos
        .map(nombre => `nombres=${encodeURIComponent(nombre)}`)
        .join('&'); 

      const url = `${baseUrl}/productos_urls?${queryString}`; 

      fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'ngrok-skip-browser-warning': 'true',
          'Content-Type': 'application/json'
        }
      })
        .then(async res => {
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
          const data = await res.json();  

          const productosConUrl = productos.map(nombre => ({
            nombre,
            url: data[nombre] || '/images/prueba.png'
          }));  

          setProductosConImagen(productosConUrl);
        })
        .catch(error => {
          console.error('[Error imagen productos]:', error);
          const productosFallback = productos.map(nombre => ({
            nombre,
            url: '/images/prueba.png'
          }));
          setProductosConImagen(productosFallback);
        });
    }
  };


  

  const obtenerIdsProductos = async (productosExtraidos) => {
    if (!Array.isArray(productosExtraidos) || productosExtraidos.length === 0) {
      console.warn('[obtenerIdsProductos] productosExtraidos no es un array válido:', productosExtraidos);
      return;
    }
    const nuevoMapa = {};
  
    await Promise.all(
      productosExtraidos.map(async (nombre) => {
        try {
          const response = await fetch(`https://bastetderma.com/swagger/api/Producto/DetalleProductoByNombre?nombre=${encodeURIComponent(nombre)}`);
          const data = await response.json();
          console.log(`[DEBUG] Respuesta para "${nombre}":`, data);
          
          // ✅ Aquí accedemos correctamente al ID
          const id = data?.productDetailModel?.id || null;
          nuevoMapa[nombre] = id;
        } catch (error) {
          console.error(`[ERROR] No se pudo obtener el ID para "${nombre}":`, error);
          nuevoMapa[nombre] = null;
        }
      })
    );
  
    setMapaNombreAId(nuevoMapa); // Asegúrate que este estado esté definido con useState
  };
  

  
  useEffect(() => {
    if (
      Array.isArray(productosExtraidos) &&
      productosExtraidos.length > 0 &&
      productosExtraidos.every(p => typeof p === 'string' && p.trim() !== '')
    ) {
      console.log('[🟢 useEffect] Se detectaron productosExtraidos válidos, mostrando modal...');
      setMostrarProductos(true);
      setMostrarModalDesdeBoton(false);
      setMostrarBotonNuevaConversacion(true);
      localStorage.setItem('mostrarBotonNuevaConversacion', 'true');

      obtenerImagenesProductos();
      obtenerIdsProductos(productosExtraidos);
    }
  }, [productosExtraidos]);

  
  
  
  

  const toggleSeleccionProducto = (producto) => {
    setProductosSeleccionados(prev => {
      if (prev.includes(producto)) {
        return prev.filter(p => p !== producto);
      } else {
        return [...prev, producto];
      }
    });
  };

const comprarProductos = (productosSeleccionados) => {
  const idsSeleccionados = productosSeleccionados
    .map(nombre => mapaNombreAId[nombre])
    .filter(id => id != null);

  console.log('[DEBUG] IDs seleccionados:', idsSeleccionados);

  if (idsSeleccionados.length > 0) {
    localStorage.setItem('chatHistorial', JSON.stringify(messages));
    window.location.href = `/detailProducts/${idsSeleccionados.join(',')}`;
  } else {
    console.log("NO HAY SELECCION DE PRODUCTOS");
    alert("⚠️ Debes seleccionar al menos un producto antes de continuar.");
    return false;  // ⚠️ IMPORTANTE: retornamos false
  }
};

  
  const onFileSelected = (event) => {
    setB(false);
    
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      setSelectedFile(file);
  
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setImagePreview(e.target.result); // esto es el base64 de la imagen
        };
        reader.readAsDataURL(file);
      }
  
      console.log('Imagen seleccionada:', file);
    }
  };

  return (
    
      <div className="chat-containered">
       
      <div className={`chat-header ${mostrarModalDesdeBoton ? 'oculto-por-modal' : ''}`}>
        <div className="left-message">¡Explícame aquí tu condición!</div>
        {mostrarBotonNuevaConversacion && (
          <button className="reset-button" onClick={resetChat}>
            Nueva conversación
          </button>
        )}
      </div>

      <div className="chat-container">
        <div className="chat-messages">
          {messages.map((msg, index) => (
            <div
              key={index}
              className={msg.sender === 'user' ? 'user' : 'bot'}
            > 
              {msg.showQR && uploadUrl && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '16px',
                    marginTop: '10px'
                  }}
                >
                  <QRCode value={uploadUrl} size={120} level="M" />

                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <p style={{ margin: 0, marginBottom: '4px' }}>Por ejemplo</p>
                    <img
                      src="/images/ejemplo.png"
                      alt="Ejemplo"
                      style={{ width: '120px', height: '120px', objectFit: 'contain' }}
                    />
                  </div>
                </div>
              )}

              {msg.imageUrl && (
                <img
                  src={msg.imageUrl}
                  alt="Imagen"
                  className="chat-message-image"
                />
              )}
  
              {msg.sender === 'bot' && msg.text && (
                <div
                  className="ms"
                  dangerouslySetInnerHTML={{ __html: msg.text }}
                />
              )}
  
              {msg.sender === 'user' && msg.text && (
                <p className="ms">{msg.text}</p>
              )}
  
              {msg.showButton && (
                <button className="boton-ver-productos" onClick={mostrarProductosModal}>
                  Ver productos
                </button>
              )}
            </div>
          ))}
  
          {isBotTyping && (
            <div className="bot-typing">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>
          )}
  
          
          <div ref={chatEndRef} /> {/* 👈 Aquí se hace el scroll */}
        </div>
  
          {mostrarProductos && mostrarModalDesdeBoton && (
            <ModalProductos
              productosConImagen={productosConImagen}
              productosSeleccionados={productosSeleccionados}
              toggleSeleccionProducto={toggleSeleccionProducto}
              comprarProductos={(productos) => {
                const exito = comprarProductos(productos);
                if (exito !== false) {
                  setMostrarModalDesdeBoton(false);  // solo cerrar si hubo selección
                  setMostrarBotonNuevaConversacion(true);
                }
              }}

              cerrarModal={() => {
                setMostrarModalDesdeBoton(false); // cierra el modal
                setMostrarBotonNuevaConversacion(true); // muestra el botón
              }}
            />
          )}

        {imagePreview && (
          <div className="preview-container">
            <img src={imagePreview} className="preview-image" alt="Preview" />
            <p className="preview-text">Previsualización</p>
          </div>
        )}
  
        <div className="chat-input">
          <div className="input-container">
            <input
              value={userMessage}
              onChange={(e) => setUserMessage(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
              placeholder="Escribe un mensaje..."
            />
  
            {/*<label htmlFor="fileInput" className="file-label">
              <img
                src="/images/add_image.png"
                alt="Seleccionar imagen"
                className="icon"
              />
            </label>
            <input
              id="fileInput"
              type="file"
              onChange={onFileSelected}
              className="file-input"
              accept="image/*"
            />*/}
          </div>
  
          <button className="send-button" onClick={sendMessage}>
            <img src="/images/send.png" alt="Enviar" className="icon" />
          </button>
        
        </div>
      </div>
    </div>
  );
  
};

export default ChatComponent;